import { DateTime, Duration } from "luxon";
import { useMemo } from "react";
import { locale } from "../../../../i18n/locale";

export const useFormattedDatasetPeriodRange = (periodRange: { from: number; to: number }) =>
  useMemo(() => {
    const fromDateTime = DateTime.fromMillis(periodRange.from).setLocale(locale);
    const toDateTime = DateTime.fromMillis(periodRange.to).setLocale(locale);
    const from = fromDateTime.toFormat("dd LLL yyyy");
    const to = toDateTime.setLocale(locale).toFormat("dd LLL yyyy");
    const durationDiff = toDateTime.diff(fromDateTime, ["years", "months", "days"]).toObject();
    const approximatedDuration = Object.fromEntries(
      Object.entries(durationDiff)
        .filter(([, value]) => value > 0)
        .map(([key, value]) => [key, Math.round(value)]),
    );
    const duration = Duration.fromObject(approximatedDuration, {
      locale,
    }).toHuman({
      listStyle: "long",
    });

    return {
      from,
      to,
      duration,
    };
  }, [periodRange]);
